import vue from 'vue';
import { default as Component } from 'vue-class-component';

@Component({
  template: require('./page-not-found.html'),
})
export class PageNotFound extends vue {

}
